import { FC, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { CustomTabPanel } from "../../../components/common/CustomTabPanel/CustomTabPanel";
import { Box, Grid, IconButton, Paper, Tab, Tabs, Typography, Button, Divider, Table, TableBody, TableHead, TableRow, TableCell } from "@mui/material";
import imagen_prueba from "../../../assets/image/imagen_puerta.png"

import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const tabData = [
    {
        label: 'Imagen 1',
        image: imagen_prueba,
    },
    {
        label: 'Imagen 2',
        image: imagen_prueba,
    },
    {
        label: 'Imagen 3',
        image: imagen_prueba,
    },
]

const producto = {
    name: 'Puera delantera derecha',
    model: 'NISSAN V16 1990-2012',
    price: '$ 200.000',
    description: 'Puerta de auto',
    type: 'Producto terminado',
    category: 'Repuestos',
    subcategoria: 'Carrocería',
    um: 'Unidades',
    imagenes: tabData
}

const products = [
    { id: 1, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 2, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 3, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 4, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 5, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
    { id: 6, name: 'Puerta delantera derecha', model: 'NISSAN V16 1990-2012', price: '$127.350', price_discount: '$110.500', img: imagen_prueba },
]



export const SearcherKFCProductModal: FC<any> = (props): JSX.Element | any => {
    const { open, closeModal } = props

    const [quantity, setQuantity] = useState<number>(1)
    const [panel, setPanel] = useState<number>(0)
    const [value, setValue] = useState(0);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setPanel(newValue)
    }


    const handleChange2 = (event, newValue) => {
        setValue(newValue);
    }

    const handleSubmit = () => {

    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick size="md">
            <ModalBody>
                <Grid item container justifyContent="space-between" xs={12}>
                    <Typography sx={{ fontWeight: 'bolder' }}>
                        Detalles del producto
                    </Typography>
                    <IconButton onClick={() => closeModal()}>
                        <CloseIcon fontSize="medium" />
                    </IconButton>
                </Grid>
                <Grid>
                    <Tabs value={panel} onChange={handleChange}>
                        <Tab label="Datos generales" />
                        <Tab label="Atributos" />
                        <Tab label="Usos" />
                        <Tab label="Complementos" />
                    </Tabs>
                    {/* Pestaña datos generales */}
                    <CustomTabPanel value={panel} index={0}>
                        <Grid container spacing={2} sx={{ height: '410px' }}>
                            <Grid item xs={12} md={6}>
                                <Box>
                                    {
                                        tabData.map((tab, index) => (
                                            <div key={index} hidden={value !== index}>
                                                {value === index && (
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <img src={tab.image} alt={tab.label} width="300" />
                                                    </div>
                                                )}
                                            </div>
                                        ))
                                    }
                                </Box>
                                <Tabs
                                    value={value}
                                    onChange={handleChange2}
                                    indicatorColor="primary"
                                    textColor="primary"
                                    centered
                                    variant="scrollable"
                                    scrollButtons="auto"
                                    aria-label="scrollable auto tabs example"
                                    style={{ width: '250px', margin: '0px auto' }}
                                >
                                    {
                                        tabData.map((tab, index) => (
                                            <Tab key={index} icon={<img src={tab.image} alt={tab.label} width="50" />} />
                                        ))
                                    }
                                </Tabs>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography sx={{ fontWeight: 'bolder', fontSize: '18px' }}>{producto.name.toUpperCase()}</Typography>
                                    <Typography sx={{ fontSize: '18px' }}>{producto.model}</Typography>
                                    <Typography sx={{ fontWeight: 'bolder', fontSize: '15px' }}>{producto.price}</Typography>
                                </Grid>
                                <Grid sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Grid>
                                        <Typography sx={{ fontSize: '15px' }}>Descripción:</Typography>
                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '15px' }}>{producto.description}</Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{ fontSize: '15px' }}>Tipo:</Typography>
                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '15px' }}>{producto.type}</Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{ fontSize: '15px' }}>Categoría:</Typography>
                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '15px' }}>{producto.category}</Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{ fontSize: '15px' }}>Subcategoría:</Typography>
                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '15px' }}>{producto.subcategoria}</Typography>
                                    </Grid>
                                    <Grid>
                                        <Typography sx={{ fontSize: '15px' }}>UM:</Typography>
                                        <Typography sx={{ fontWeight: 'bolder', fontSize: '15px' }}>{producto.um}</Typography>
                                    </Grid>
                                </Grid>
                                <Grid>
                                    <Typography sx={{ fontSize: '15px' }}>Cantidad:</Typography>
                                    <IconButton
                                        sx={{ background: '#516E80', marginLeft: '10px', width: '30px', height: '30px', '&:hover': { background: '#516E80' } }}
                                        onClick={() => setQuantity(quantity - 1)}
                                    >
                                        <RemoveIcon fontSize="small" sx={{ color: '#ffffff' }} />
                                    </IconButton>
                                    <Typography sx={{ fontSize: '15px', marginLeft: '10px' }}>{quantity}</Typography>
                                    <IconButton
                                        sx={{ background: '#516E80', marginLeft: '10px', width: '30px', height: '30px', '&:hover': { background: '#516E80' } }}
                                        onClick={() => setQuantity(quantity + 1)}
                                    >
                                        <AddIcon fontSize="small" sx={{ color: '#ffffff' }} />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={12} sx={{ marginTop: '15px' }}>
                                    <Button
                                        onClick={() => handleSubmit()}
                                        sx={{ backgroundColor: '#EAA158', borderRadius: '20px', color: '#fff', float: 'left', height: '25px', padding: '6px 16px', textTransform: 'none', width: 160, "&:hover": { backgroundColor: "#EAA158" } }}
                                    >
                                        Añadir al carrito
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CustomTabPanel>
                    {/* Pestaña atributos */}
                    <CustomTabPanel value={panel} index={1}>
                        <Grid container sx={{ height: '410px', marginTop: '10px' }}>
                            <Table>
                                <TableBody>
                                    <TableRow sx={{ backgroundColor: '#f8f9f9' }}>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Marca</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>NISSAN</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Modelo</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>V16 1990-2012</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: '#f8f9f9' }}>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Categoría</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>Repuestos</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Garantía</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>Un año</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                <TableRow sx={{ backgroundColor: '#f8f9f9' }}>
                                    <TableCell>
                                        <Typography fontWeight={'bold'}>Medidas</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>150cm x 100cm</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography fontWeight={'bold'}>Peso</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>12.4 Kg</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow sx={{ backgroundColor: '#f8f9f9' }}>
                                    <TableCell>
                                        <Typography fontWeight={'bold'}>Material</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>Acero</Typography>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <Typography fontWeight={'bold'}>Información adicional</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consectetur molestias ratione aut animi ex magnam velit, quis, dicta quia natus ipsam corporis soluta aspernatur facere debitis laboriosam? Officia, pariatur quos.</Typography>
                                    </TableCell>
                                </TableRow>
                            </Table>
                        </Grid>
                    </CustomTabPanel>
                    {/* Pestaña usos */}
                    <CustomTabPanel value={panel} index={2}>
                        <Grid container sx={{ height: '410px', marginTop: '10px' }}>
                            <Table>
                                <TableBody>
                                    <TableRow sx={{ backgroundColor: '#f8f9f9' }}>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Uso específico</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta, iure rem? Quam, inventore. Eos, sit. Commodi repellat voluptatibus quasi aut unde atque, ipsam in voluptas laboriosam id fugiat magnam. Ipsam?</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Marcas de uso</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>NISSAN</Typography>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow sx={{ backgroundColor: '#f8f9f9' }}>
                                        <TableCell>
                                            <Typography fontWeight={'bold'}>Modelos compatibles</Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Typography>NISSAN v16-2001 | NISSAN v15-2005</Typography>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Grid>
                    </CustomTabPanel>
                    {/* Pestaña complementos */}
                    <CustomTabPanel value={panel} index={3}>
                        <Grid container spacing={2} sx={{ height: '410px' }}>
                            <Grid item xs={12}>
                                <Typography sx={{ marginRight: 'auto' }}>Otros productos que pueden interesar según tu compra</Typography>
                            </Grid>
                            <Grid item style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                {
                                    products.map((product, index) => (
                                        <Box key={index} style={{ display: 'inline-block', margin: '5px', padding: '5px' }}>
                                            <Grid item>
                                                <img src={product.img} alt={product.name} />
                                            </Grid>
                                            <Divider sx={{ margin: '10px 0px' }} />
                                            <Grid item display="flex" justifyContent="center">
                                                <Typography sx={{ color: '#CA0000', fontWeight: 'bolder', margin: '0px 5px' }}>{product.price}</Typography>
                                                <Typography sx={{ color: '#000000', textDecoration: 'line-through', margin: '0px 5px' }}>{product.price_discount}</Typography>
                                            </Grid>
                                            <Grid item display="flex" justifyContent="center">
                                                <Typography sx={{ color: '#000000', fontWeight: 'bolder' }}>{product.name}</Typography>
                                            </Grid>
                                            <Grid item display="flex" justifyContent="center">
                                                <Typography>{product.model}</Typography>
                                            </Grid>
                                            <Grid item display="flex" justifyContent="center" sx={{ marginTop: '10px' }}>
                                                <Button
                                                    sx={{
                                                        backgroundColor: '#516E80',
                                                        borderRadius: '10px',
                                                        color: '#ffffff',
                                                        height: '25px',
                                                        padding: '6px 16px',
                                                        textTransform: 'none',
                                                        width: 150,
                                                        "&:hover": { backgroundColor: "#516E80" }
                                                    }}
                                                >
                                                    Añadir al carrito
                                                </Button>
                                            </Grid>
                                        </Box>
                                    ))
                                }
                            </Grid>
                        </Grid>
                    </CustomTabPanel>
                </Grid>
            </ModalBody>
        </Modal>
    )
}